<template>
 <div id="feedback">
 	<mt-header title="意见反馈"  fixed>
		  <a href="javascript:void(0)" slot="left" @click="returnBack">
		    <mt-button icon="back" class="font-Yahei"></mt-button>
		  </a>
	</mt-header>
	<div class="mt40">
	  <div class="feedbox mt10">
	  	<input type="text" v-model="contactway" class="contactway" maxlength="50" placeholder="请输入你的联系方式，手机号/QQ/邮箱"/>
	  </div>
	  <p class="colorBox"></p>
	  <div class="feedbox">
	  	<textarea class="problem" maxlength="100" v-model="problem" placeholder="请简单描述你的问题" @input="descText"></textarea>
	    <p class="textarea-text"><span>{{current}}</span>/100</p>
	  </div>
	  <p class="btn-ok-box"><input type="button" value="提交" class="btnLogin" @click="btnOk"/></p>
	</div>
 </div>
</template>

<script>
	import { Toast } from 'mint-ui'   
    import { MessageBox } from 'mint-ui';
    import { Indicator } from 'mint-ui'
	export default{
		data(){
			return{
			  username:localStorage.getItem("username"),
			  contactway:"",
			  problem:"",
			  current:0
			}
		},
		created:function(){
			
	    },
	    methods:{
	    	returnBack(){
	       	 this.$router.go(-1);
	        },
	    	descText(){
	    	   var txtVal = this.problem.length; 
               this.current = txtVal;
	    	},
	    	btnOk(){
	    	  if(this.contactway==""){
	    	  	  Toast("请输入联系方式");
	    	  	  return false;
	    	  }else if(this.problem==""){
	    	  	  Toast("请输入你需要反馈的问题");
	    	  	  return false;
	    	  }else if(this.problem.length<5){
	    	  	  Toast("问题反馈内容不少于5个字");
	    	  	  return false;
	    	  }else{
	    	  	Indicator.open();
	    	  	this.$http.post(this.URL_PREFIX+"/feedback/saveFeedback.net",{uId:this.username,contact:this.contactway,body:this.problem})
		  	    .then((res) =>{
		  	      Indicator.close();
		  	      if(res.data.code==200){
		  	      	 MessageBox({
					  title: '提示',
					  message: '您的反馈已成功提交，我们会仔细聆听您的意见，并努力提供更优质的服务',
					  confirmButtonText:"我知道了"
					}).then(action => {
					   this.$router.go(-1);
			        });
		  	      }else{
		  	      	 Toast(res.data.msg);
		  	      }     
		  	    });
	    	  }
	    	}
	    }
	}
</script>

<style scoped="scoped">
@import "../../../static/css/user.css";
.feedbox{border-top:1px solid #eee;border-bottom: 1px solid #eee;background: #fff;padding: 10px 20px 10px 20px;}
.contactway,.problem{width:90%;font-size: 0.9rem;color: #333;border: none;}
.problem{height: 150px;overflow-y: scroll;}
.btn-ok-box{width: 90%;margin: 0 auto;}
.textarea-text{font-size: 0.7rem;color: #999;text-align: right;}
</style>


// WEBPACK FOOTER //
// src/views/UserCenter/feedBack.vue